// extracted by mini-css-extract-plugin
module.exports = {"ArticleTags":"styles_ArticleTags__2rTpT","tag":"styles_tag__3IjPy"};